<template>
    <div>
        <b-table
            :items="documentsStateData"
            :fields="documentsColumns"
            responsive
            primary-key="id"
            show-empty
            sticky-header
            striped
            editable
            empty-text="No hay registros"
            @row-clicked="handleRowClick"

        >
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(transfer_date)="{ item }">
                <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.transfer_date"
                            class="form-control width-115"
                            name="transfer_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                        />
                    </template>
                    <template v-else>
                         <span class="text-nowrap">
                            {{ item.transfer_date }}
                        </span>
                    </template>
                </div>
            </template>

            <template #cell(end_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.end_date"
                        class="form-control width-115"
                        name="end_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                    <span class="text-nowrap">
                           {{ item.end_date }}
                    </span>
                </template>
            </template>

          <template #cell(contract_date)="{ item }">
            <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
              <template v-if="isRowEditable(item)">
                <flat-pickr
                    v-model="item.contract_date"
                    class="form-control width-115"
                    name="start_date"
                    autocomplete="off"
                    :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                />
              </template>
              <template v-else>
                    <span class="text-nowrap">
                       {{ item.start_date }}
                    </span>
              </template>
            </div>
          </template>

          <template #cell(start_date)="{ item }">
            <template v-if="isRowEditable(item)">
              <flat-pickr
                  v-model="item.start_date"
                  class="form-control width-115"
                  name="start_date"
                  autocomplete="off"
                  :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
              />
            </template>
            <template v-else>
                  <span class="text-nowrap">
                     {{ item.start_date }}
                  </span>
            </template>
          </template>

          <template #cell(contract_start_date)="{ item }">
              <template v-if="isRowEditable(item)">
                  <flat-pickr
                      v-model="item.contract_start_date"
                      class="form-control width-115"
                      name="start_date"
                      autocomplete="off"
                      :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                  />
              </template>
              <template v-else>
                  <span class="text-nowrap">
                     {{ item.contract_start_date }}
                  </span>
              </template>
          </template>

          <template #cell(contract_end_date)="{ item }">
              <template v-if="isRowEditable(item)">
                <flat-pickr
                    v-model="item.contract_end_date"
                    class="form-control width-115"
                    name="start_date"
                    autocomplete="off"
                    :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                />
              </template>
              <template v-else>
                          <span class="text-nowrap">
                             {{ item.contract_end_date }}
                          </span>
              </template>
          </template>

            <template #cell(received_date)="{ item }">
                <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.received_date"
                            class="form-control width-115"
                            name="start_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                        />
                    </template>
                    <template v-else>
                         <span class="text-nowrap">
                             {{ item.received_date }}
                          </span>
                    </template>
                </div>
            </template>

          <template #cell(signature_date)="{ item }">
            <div :style="{ backgroundColor: item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '' }">
              <template v-if="isRowEditable(item)">
                <flat-pickr
                    v-model="item.signature_date"
                    class="form-control width-115"
                    name="start_date"
                    autocomplete="off"
                    :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                />
              </template>
              <template v-else>
                         <span class="text-nowrap">
                             {{ item.signature_date }}
                          </span>
              </template>
            </div>
          </template>

            <template #cell(exam_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.exam_date"
                        class="form-control width-115"
                        name="start_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                     <span class="text-nowrap">
                             {{ item.exam_date }}
                     </span>
                </template>
            </template>

            <template #cell(observations)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.observations" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.observations }}
                </template>
            </template>

            <template #cell(scope)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.scope" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.scope }}
                </template>
            </template>

            <template #cell(obralia_exp)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.obralia_exp" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.obralia_exp }}
                </template>
            </template>

            <template #cell(provider_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.provider_id"
                        class="pt-0 width-300" label="provider" name="provider"
                        :reduce="(option) => option.id"
                        :options="providers"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        providers.find(element => element.id == item.provider_id) ? providers.find(element => element.id == item.provider_id).provider : ''
                    }}
                </template>
            </template>

            <template #cell(project_responsible_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.project_responsible_id"
                        class="pt-0 width-400" label="name" name="name"
                        :reduce="(option) => option.id"
                        :options="responsibles"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{ responsibles.find(element => element.id == item.project_responsible_id) ? responsibles.find(element => element.id == item.project_responsible_id).name : '' }}
                </template>
            </template>

            <template #cell(document_type_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.document_type_id"
                        class="pt-0 width-200" label="type" name="type"
                        :reduce="(option) => option.id"
                        :options="documentsTypes"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        documentsTypes.find(element => element.id == item.document_type_id) ? documentsTypes.find(element => element.id == item.document_type_id).type : ''
                    }}
                </template>
            </template>


            <template #cell(options)="data">
                <div class="d-flex align-items-center" @click.stop>
                    <feather-icon
                        v-if="createPermission && !showLoading"
                        :id="`record-row-${data.item.id}-edit-icon`"
                        :icon="getButtonIcon(data.item)"
                        class="cursor-pointer mr-1"
                        :class="getButtonVariant(data.item)"
                        size="16"
                        @click="handleIconClick(data.item)"
                    />

                    <feather-icon
                        v-if="data.item.id && !showLoading"
                        :id="`record-row-${data.item.id}-see-icon`"
                        icon="SearchIcon"
                        size="16"
                        variant="warning"
                        class="cursor-pointer mr-1 text-blue"
                        @click="seeDocumentsList(data.item.id)"
                    />
                    <feather-icon
                        v-if="deletePermission && !showLoading"
                        :id="`record-row-${data.item.id}-delete-icon`"
                        icon="TrashIcon"
                        size="16"
                        class="cursor-pointer text-red"
                        @click="deleteRecord(data.item.id, data.index )"
                    />
                    <b-spinner
                        v-if="showLoading"
                        small
                        variant="secondary"
                    ></b-spinner>
                </div>
            </template>

        </b-table>

        <b-modal v-model="showModal" hide-footer title="Documentos" size="lg">
            <b-table
                ref="refUserListTable"
                :items="documentsRoute"
                responsive
                :fields="columnsDocuments"
                primary-key="id"
                show-empty
                sticky-header
                striped
                editable
                empty-text="No hay registros"
                class="table-bordered "
                :key-field="'index'"
            >
                <template #cell(options)="data">
                    <div class="d-flex align-items-center justify-content-center">
                        <a href="javascript:void(0)" @click.prevent="openDocument(data.item.path, data.item.name)">
                            <feather-icon
                                v-if="!can('vhe_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-see-icon`"
                                icon="EyeIcon"
                                size="16"
                                variant="warning"
                                class="cursor-pointer mr-1 text-blue"
                            />
                        </a>
                        <a href="javascript:void(0)" @click.prevent="downloadDocument(data.item.path, data.item.name)">
                            <feather-icon
                                v-if="!can('vhe_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-download-icon`"
                                icon="DownloadIcon"
                                size="16"
                                class="cursor-pointer mr-1 text-blue"
                            />
                        </a>
                        <feather-icon
                            v-if="!can('vhe_delete_document_contract_client_ee')"
                            :id="`record-row-${data.item.id}-delete-icon`"
                            icon="TrashIcon"
                            size="16"
                            class="cursor-pointer text-red"
                            @click="deleteDocument(data.item.id, data.item.path)"
                        />
                    </div>
                </template>
            </b-table>
            <template>
                <div v-if="currentDocumentId>0">
                    <b-overlay
                        variant="white"
                        :show="showLoading"
                        spinner-variant="primary"
                        blur="0"
                        opacity=".75"
                        rounded="sm"
                    >
                        <vue-dropzone
                            id="dropzone"
                            ref="dropzone"
                            :options="dropzoneOptions"
                            :use-custom-slot="true"
                            @vdropzone-complete="complete"
                            @vdropzone-error="handleDropzoneError"
                        >
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Arrastrar y soltar para subir archivo</h3>
                                <div class="subtitle">...o hacer clic para seleccionar un archivo de tu ordenador
                                </div>
                            </div>
                        </vue-dropzone>
                    </b-overlay>
                </div>
            </template>

            <b-button class="mt-3" variant="outline-danger" block @click="closeModal()">Cerrar</b-button>
        </b-modal>
    </div>
</template>

<script>
import {BTable, BFormInput, BModal, BButton, BOverlay, BSpinner} from 'bootstrap-vue'
import {baseUrl} from "@/constants/app"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import authService from "@/services/auth/authService"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import flatPickr from "vue-flatpickr-component"
import VueDropzone from "vue2-dropzone"
import helper from "@/resources/helpers/helpers"
import Swal from "sweetalert2"
import vSelect from "vue-select"
import {mapState} from "vuex"
import {mapFields} from "vuex-map-fields"
import {createPopper} from '@popperjs/core'

export default {
    components: {
        BSpinner,
        BTable,
        BFormInput,
        BModal,
        BButton,
        BOverlay,
        flatPickr,
        vSelect,
        VueDropzone: VueDropzone,
    },
    props: {
        documentsStateData: {
            type: Array,
            required: true
        },
        documentsColumns: {
            type: Array,
            required: true
        },
        documentsRoute: {
            type: Array,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        createPermission: {
            type: Boolean,
        },
        deletePermission: {
            type: Boolean,
        }
    },

    data() {
        return {
            baseUrl,
            currentDocumentId: null,
            selectedRow: null,
            placement: 'top',

            showModal: false,
            SpanishLocale,
            edit: false,
            showLoading: false,
            urlDocs: null,
            editedRow: null,
            columnsDocuments: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'name', label: 'Archivo', sortable: false},
            ],
            dropzoneOptions: {},
        }
    },
    computed: {
        ...mapState('providersVhe', []),
        ...mapState('documentsTypesVhe', []),
        ...mapFields({
            providers: 'providersVhe.providers',
            responsibles: 'projectResponsibleVhe.project_responsibles',
            documentsTypes: 'documentsTypesVhe.document_types',
        }),
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        withPopper(dropdownList, component, {width}) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({state}) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
        isRowEditable(item) {
          if (!this.deletePermission) {
            return false
          }
          return item === this.editedRow || item === this.documentsStateData.editedRow
        },
        handleIconClick(item) {
          if (!this.editedRow && this.editedRow?.id !== item.id) {
            this.handleRowClick(item)
          } else {
            this.editRow(item)
          }
        },
        handleRowClick(item) {
          if (!this.isRowEditable(item) && !this.editedRow) {
            this.editedRow = item
          }
        },
        editRow(item) {
          this.updateRecord(this.editedRow, item)
          this.editedRow = null
        },
        getButtonVariant(item) {
            return this.isRowEditable(item) ? 'text-green' : 'info'
        },
        getButtonIcon(item) {
            return this.isRowEditable(item) ? 'CheckIcon' : 'EditIcon'
        },
        getButtonText(item) {
            return this.isRowEditable(item) ? 'Guardar' : 'Editar'
        },
        closeModal() {
            this.showModal = false
            this.$root.$refs.masterInstallationForm.getMasterInstallation()
        },
        seeDocumentsList(id) {
            this.currentDocumentId = id
            this.updateDropzoneOptions()
            this.$store.dispatch('masterInstallationDocumentsVhe/getDocumentsList', {id: id, context: this.context})
            .then(response => {
                this.showLoading = false
                this.showModal = true
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        updateDropzoneOptions() {
            this.dropzoneOptions = {
                url: baseUrl + 'api/vhe/master-installation/general-data/' + this.context + '/upload-documents/' + this.currentDocumentId,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                autoProcessQueue: true,
                addRemoveLinks: true,
                headers: {"Authorization": 'Bearer ' + authService.accessToken()},
            }
        },
        complete: function (file) {
            this.showLoading = true
            this.seeDocumentsList(this.currentDocumentId)
            setTimeout(() => {
                this.$refs.dropzone.removeAllFiles()
            }, 2000)
        },
        handleDropzoneError(file, message, xhr) {
          message.errors.file.forEach(error =>
              helper.showToast(error, 'AlertOctagonIcon', 'danger')
          )
        },
        async updateRecord(updatedItem, item) {
          try {
            this.showLoading = true

            if (!updatedItem || item.id !== updatedItem?.id) {
              item.context = this.context
              await this.$store.dispatch('masterInstallationDocumentsVhe/createRecordGeneralData', item)
              helper.showToast('Registro creado correctamente!', 'CheckIcon', 'success')
            }

            if (updatedItem)  {
              updatedItem.context = this.context
              await this.$store.dispatch('masterInstallationDocumentsVhe/updateRecordGeneralData', updatedItem)
              helper.showToast('Registro actualizado correctamente!', 'CheckIcon', 'success')
            }

            this.$root.$refs.masterInstallationForm.getMasterInstallation()
            helper.resetVariable(this.record)

          } catch (error) {
            helper.showToast('Error al procesar la solicitud', 'AlertOctagonIcon', 'danger')
          } finally {
            this.showLoading = false
          }
        },
        deleteRecord(id, index) {
            if (id) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el registro?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('masterInstallationDocumentsVhe/deleteRecord', {
                            id: id,
                            context: this.context
                        })
                        .then(response => {
                            this.showLoading = false
                            helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                            this.$root.$refs.masterInstallationForm.getMasterInstallation()
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            } else {
                this.documentsStateData.splice(index, 1)
            }
        },
        deleteDocument(recordId, path) {
            if (recordId) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el archivo?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('masterInstallationDocumentsVhe/deleteDocument', {
                            id: this.currentDocumentId,
                            path: path,
                            context: this.context
                        })
                        .then(response => {
                          this.showLoading = false
                          this.$root.$refs.masterInstallationForm.getMasterInstallation()
                          helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                          this.seeDocumentsList(this.currentDocumentId)
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            }
        },

    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>